import React from "react";

type CounterProps = {
  quantity: number;
  add?: () => void;
  remove?: () => void;
  hideButtons?: boolean;
  className?: string;
};

const Counter = ({
  quantity,
  add,
  remove,
  hideButtons,
  className,
}: CounterProps) => {
  return (
    <div className={`counter-container ${className ?? ""}`}>
      {!hideButtons && (
        <>
          <button
            type="button"
            disabled={!remove}
            onClick={remove}
            aria-label="Decrease quantity"
            className="counter-button"
          >
            −
          </button>
          <div
            className="counter-value"
            aria-live="polite"
            aria-label={`Quantity: ${quantity}`}
          >
            {quantity}
          </div>
          <button
            type="button"
            disabled={!add}
            onClick={add}
            aria-label="Increase quantity"
            className="counter-button"
          >
            +
          </button>
        </>
      )}
    </div>
  );
};

export default Counter;
